<template>
    <div class="checkout_product_row-border checkout_product_row-undo">
        <p class="checkout_product_row-undo-message">
            <span class="checkout_product_row-undo-item">{{ props.itemName }}</span>
            removed from your order.
        </p>
        <button
            type="button"
            class="checkout_product_row-undo-action"
            aria-label="Undo remove item"
            @click="emit('undo')"
        >
            Undo
        </button>
    </div>
</template>
<script lang="ts" setup>
    const props = defineProps({
        itemName: {
            type: String,
            default: "Item",
        },
    });

    const emit = defineEmits(["undo"]);
</script>
